import React from 'react';
import PropTypes from 'prop-types';
import StepZero from './StepZero';
import StepOne from './StepOne';
import StepPersonal from './StepPersonal';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';

const CurrentStep = ({ activeStep, data, onNext, onBack }) => {
  switch (activeStep) {
    case 1:
      return <StepZero data={data} onNext={onNext} />;
    case 2:
      return <StepOne data={data} onNext={onNext} onBack={onBack} />;
    case 3:
      return <StepPersonal data={data} onNext={onNext} onBack={onBack} />;
    case 4:
      return <StepTwo data={data} onNext={onNext} onBack={onBack} />;
    case 5:
      return <StepThree data={data} onNext={onNext} onBack={onBack} />;
    case 6:
      return <StepFour data={data} onNext={onNext} onBack={onBack} />;
    default:
      return null;
  }
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  data: PropTypes.object,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired
};

export default CurrentStep;
